import React from 'react';
import { SVGProps } from '../types';

const FileIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2.97 9.158c.284-.696 1.59-2.076 4.58-2.076.252 0 .91-.253.876-1.622-.014-1.237.438-3.686 2.33-3.791.375-.002.782-.002 1.228-.002 1.5 0 2.249 0 2.847.21.963.338 1.722 1.053 2.081 1.958.223.564.223 1.27.223 2.68v7.652c0 .774 0 1.162-.064 1.484a3.333 3.333 0 01-2.619 2.619c-.322.064-.709.064-1.483.064h-3.56c-2.719 0-4.077 0-5.021-.665-.27-.19-.51-.417-.713-.671-.706-.888-.706-2.167-.706-4.725v-2.121-.994z"
        opacity="0.4"
      />
      <path
        stroke="currentColo"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M13.333 14.167H7.5M13.333 10.834h-2.5"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M17.083 11.667c0 3.143 0 4.714-1.037 5.69-1.037.977-2.707.977-6.046.977h-.644c-2.718 0-4.076 0-5.02-.665-.27-.19-.51-.417-.713-.671-.706-.888-.706-2.167-.706-4.725v-2.121c0-2.47 0-3.704.39-4.69.629-1.585 1.957-2.836 3.642-3.427 1.047-.368 2.36-.368 4.983-.368 1.5 0 2.249 0 2.847.21.963.338 1.722 1.053 2.081 1.958.223.564.223 1.27.223 2.68v5.152z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M2.917 10a2.778 2.778 0 012.777-2.777c.555 0 1.21.097 1.749-.048.48-.128.853-.503.982-.982.144-.54.047-1.193.047-1.748a2.778 2.778 0 012.778-2.778"
      />
    </svg>
  );
};

export { FileIcon };
